export const useIsShortMobileDevice = (): boolean => {
  return false
}
